var _defs, _path, _path2, _g, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitivos3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5e7076;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.47,82.6l-6.75-.51c2.88-38.09,28.71-63.68,64.27-63.68s61.4,25.59,64.29,63.68l-6.75,.51c-2.64-34.88-25.23-57.42-57.54-57.42s-54.88,22.54-57.52,57.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.87,82.97c-5.06-26.78-21.46-42.76-43.88-42.76s-38.81,15.99-43.87,42.76l-6.65-1.26c5.71-30.23,24.59-48.28,50.52-48.28s44.82,18.05,50.53,48.28l-6.65,1.26Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.6,139.78h-10.84c-10.86,0-19.7-8.84-19.7-19.7v-21.41c0-10.86,8.84-19.7,19.7-19.7h10.84c3.67,0,6.66,2.99,6.66,6.66v47.49c0,3.68-2.99,6.66-6.66,6.66Zm-10.84-54.05c-7.13,0-12.94,5.8-12.94,12.94v21.41c0,7.13,5.8,12.94,12.94,12.94h10.73v-47.28h-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.24,139.78h-10.84c-3.67,0-6.66-2.99-6.66-6.66v-47.49c0-3.67,2.99-6.66,6.66-6.66h10.84c10.86,0,19.7,8.84,19.7,19.7v21.41c0,10.86-8.84,19.7-19.7,19.7Zm-10.74-6.77h10.74c7.13,0,12.94-5.8,12.94-12.94v-21.41c0-7.13-5.8-12.94-12.94-12.94h-10.74v47.28Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.18,171.87v-6.77c15.73,0,28.52-12.79,28.52-28.52v-.18h6.77v.18c0,19.46-15.83,35.29-35.29,35.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.64,181.59h-12.71c-5.71,0-10.35-4.64-10.35-10.35v-4.03c0-5.71,4.64-10.35,10.35-10.35h12.71c5.71,0,10.35,4.64,10.35,10.35v4.03c0,5.71-4.64,10.35-10.35,10.35Zm-12.71-17.97c-1.98,0-3.58,1.61-3.58,3.58v4.03c0,1.98,1.61,3.58,3.58,3.58h12.71c1.98,0,3.58-1.61,3.58-3.58v-4.03c0-1.98-1.61-3.58-3.58-3.58h-12.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitivos3);
export default __webpack_public_path__ + "static/media/competitivos3.05191ef9e471e5353bc26691d0897aab.svg";
export { ForwardRef as ReactComponent };